/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityAddressDetailInfo = {
    ADDR: string;
    ADDRT: HumanityAddressDetailInfo.ADDRT;
    NM: string;
    BL: string;
    BLP: string;
    TKNCNT: string;
    FTRXUT: number;
    LTRXUT: number;
    CCADDR: string;
    CTRXHA: string;
};

export namespace HumanityAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

